<template>
	<div class="appoint-theme-wrap">
		<p class="title">约会主题</p>
		<div class="theme-list">
			<ul>
				<li v-for="item in themeList.sincerity" :class="{'active':item.s_id==choosedThemeId}" @click="chooseTheme(item.s_id,item.name)">
					<img :src="item.img"/>
					<p>{{item.name}}</p>
					<span class="item-choosed"><img src="../../assets/img/finds/ic_sel_yes@2x.png"/></span>
				</li>
				<li v-for="item in themeList.custom" :class="{'active':item.s_id==choosedThemeId}" @click="chooseTheme(item.s_id,item.name)">
					<img :src="item.img"/>
					<p>{{item.name}}</p>
					<span class="item-choosed"><img src="../../assets/img/finds/ic_sel_yes@2x.png"/></span>
					<span class="item-del" @click.stop="delOtherTheme(item.s_id)"><img src="../../assets/img/finds/ic_sel_del@2x.png"/></span>
				</li>
				<li v-for="item in otherThemeList" :class="{'active':item.s_id==choosedThemeId}" @click="chooseTheme(item.s_id,item.name)">
					<img :src="item.img"/>
					<p>{{item.name}}</p>
					<span class="item-choosed"><img src="../../assets/img/finds/ic_sel_yes@2x.png"/></span>
				</li>
			</ul>
		</div>
		<div class="other-theme-wrap" v-if="showOtherTheme">
			<div class="edit-box">
				<img @click="choosedThemeId=''" src="../../assets/img/finds/ic_pop_del@2x.png"/>
				<div class="add-edit-theme">
					<p class="theme-title">自定义约会主题</p>
					<input type="text" placeholder="输入自定义主题名称，不超过四个字" v-model="otherThemeName"/>
					<ul>
						<li v-for="item in themeList.custom_hot" :class="{'active':item.s_id==otherThemeId}" @click="chooseOtherTheme(item)">{{item.name}}</li>
					</ul>
					<p class="theme-btn">
						<button @click="submitOtherTheme">添加自定义主题</button>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"appoint-theme",
		props:["uid"],
		data(){
			return{
				themeList:"",
				choosedThemeId:"",
				otherThemeId:"",
				otherThemeName:"",
				otherThemeList:[],
				showOtherTheme:0,
			}
		},
		created(){
			this.getThemeList();
		},
		watch:{
			choosedThemeId(){
				if(this.choosedThemeId==100){
					this.showOtherTheme = 1;
				}else{
					this.showOtherTheme = 0;
				}
			}
		},
		methods:{
			getThemeList(){
				this.$axios({
					url:"Appointment/AppointmentSincerityList",
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.themeList = res.data.data;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			chooseTheme(id,name){
				this.choosedThemeId = id;
				let choosedTheme = {
					id:this.choosedThemeId,
					name:name
				}
				this.$emit("chooseTheme",choosedTheme);
			},
			chooseOtherTheme(item){
				console.log(item);
				this.otherThemeName = item.name;
			},
			submitOtherTheme(){
				let v = this.otherThemeName;
				let themes = this.themeList.sincerity;
				for(let i=0;i<themes.length;i++){
					console.log(themes[i].name,v)
//					if(themes[i].name==v){
//						console.log("1")
//					}else{
//						console.log("2")
//					}
					if(themes[i].name == v){
						console.log("you");
						this.choosedThemeId = themes[i].s_id;
						let choosedTheme = {
							id:this.choosedThemeId,
							name:themes[i].name
						}
						this.$emit("chooseTheme",choosedTheme);
						this.showOtherTheme = 0;
						this.otherThemeName = "";
						break;
					}else{
						console.log("wu");
						this.otherThemeId = 0;
						let obj = [{name:this.otherThemeName,s_id:this.otherThemeId,img:require("../../assets/img/finds/ic_sel_other@2x.png")}];
						this.otherThemeList = obj;
						this.choosedThemeId = 100;
						let choosedTheme = {
							id:this.choosedThemeId,
							name:this.otherThemeName
						}
						this.$emit("chooseTheme",choosedTheme);
						this.showOtherTheme = 0;
						this.otherThemeName = "";
						break;
					}
					
				}
			},
			delOtherTheme(id){
				console.log(id);
				this.$axios({
					url:"Appointment/DelAppointmentSincerityCustom",
					method:"post",
					data:{
						uid:this.uid,
						s_id:id
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message:res.data.msg,
							position:"bottom",
							duration:3000
						});
						this.getThemeList()
					}
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
	.appoint-theme-wrap{
		padding: 0.5rem 1rem 0;
	}
	.appoint-theme-wrap .title{
		background: url(../../assets/img/finds/ic_list_tab@2x.png) no-repeat left center;
	    background-size: contain;
	    padding-left: 1.6rem;
	    font-size: 1rem;
	    color: #282828;
	    font-weight: bold;
	    line-height: 1.5rem;
	    margin: 0.5rem 0;
	}
	.appoint-theme-wrap ul{
	    display: flex;
	    justify-content: flex-start;
	    align-items: center;
	    flex-wrap: wrap;
	}
	.appoint-theme-wrap li{
		width: 25%;
		padding: 0.5rem 1rem 0.5rem;
		text-align: center;
		position: relative;
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.appoint-theme-wrap li img{
		width: 100%;
	}
	.appoint-theme-wrap li .item-choosed{
		position: absolute;
		top: 0;
		right: 0;
		display: none;
	}
	.appoint-theme-wrap li.active{
		color: #5415F9;
	}
	.appoint-theme-wrap li.active .item-choosed{
		display: block;
	}
	.appoint-theme-wrap li.active .item-del{
		display: none;
	}
	.appoint-theme-wrap .item-choosed img{
		width: 1.2rem;
	}
	.appoint-theme-wrap li .item-del{
		position: absolute;
		top: 0;
		right: 0;
	}
	.appoint-theme-wrap li .item-del img{
		width: 1.2rem;
	}
	.other-theme-wrap{
		position: fixed;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,.3);
		display: flex;
		justify-content: center;
		align-items: center;
		top: 0;
		left: 0;
		z-index: 10;
		padding: 1rem;
	}
	.other-theme-wrap .edit-box{
		width: 100%;
		text-align: center;
	}
	.other-theme-wrap .edit-box img{
		width: 1.5rem;
	}
	.other-theme-wrap .add-edit-theme{
		background: #fff;
		padding: 1rem 1.5rem 2rem;
		border-radius: 1rem;
	}
	.other-theme-wrap .add-edit-theme .theme-title{
		font-size: 1rem;
		margin-bottom: 1rem;
		color: #282828;
		font-weight: bold;
	}
	.other-theme-wrap .add-edit-theme input{
		width: 100%;
		height: 2.6rem;
		border-radius: 3rem;
		border: 0;
		outline: 0;
		background: #f3f3f3 url(../../assets/img/finds/ic_text_import@2x.png) no-repeat 0.8rem center;
		background-size: 1.5rem;
		padding: 0 0.5rem 0 3rem;
	}
	.other-theme-wrap .add-edit-theme ul{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		margin-top: 1rem;
	}
	.other-theme-wrap .add-edit-theme li{
		background: #ededed;
		color: #282828;
		margin: 0.5rem 0.5rem 0;
		border-radius: 2rem;
		border: 1px solid #ededed;
		padding: 0.3rem 0;
	}
	.other-theme-wrap .add-edit-theme li.active{
		background: #ebe3fe;
		color: #5415F9;
		border: 1px solid #5415F9;
	}
	.other-theme-wrap .add-edit-theme .theme-btn{
		margin-top: 1.5rem;
	}
	.other-theme-wrap .add-edit-theme .theme-btn button{
		width: 100%;
		height: 2.5rem;
		background: linear-gradient(to right,#7644fa,#9d7cff);
		border-radius: 5px;
		border: 0;
		outline: 0;
		color: #fff;
		font-size: 0.8rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/AppointTheme.vue